@if (chatMessage.type == chatMessageTypeEnum.User) {
  <div class="message" [class.me]="chatMessage.userId == currentUserId">
    @if (chatMessage.userName) {
      <div class="participant" [style.color]="color">
        <p>{{ chatMessage.userName }}</p>
      </div>
    }
    @if (!chatMessage.userName) {
      <div class="participant" [style.color]="color">
        <p>{{ "GUEST" | translate }}</p>
      </div>
    }
    <div class="globe" [class.media]="chatMessage.chatFile != undefined && chatMessage.chatFile.mediaType != mediaTypeEnum.Audio" [class.audio-message]="chatMessage.chatFile?.mediaType == mediaTypeEnum.Audio" [style.background]="backgroundColor" [style.border]="borderColor">
      @if (chatMessage.chatFile != undefined) {
        <div class="message-content">
          @if (chatMessage.chatFile.fileId == 0) {
            <div class="load-waiting"></div>
          } @else {
            @if (chatMessage.chatFile.mediaType == mediaTypeEnum.Image) {
              <div><img [src]="chatMessage.chatFile.url" (click)="openMediaModal(chatMessage.chatFile.url!, chatMessage.chatFile.mediaType)" (load)="loaded()"></div>
            }
            @if (chatMessage.chatFile.mediaType == mediaTypeEnum.Video) {
              <div><video [src]="chatMessage.chatFile.url" [poster]="videoPoster" controls (loadeddata)="loaded()"></video></div>
            }
            @if (chatMessage.chatFile.mediaType == mediaTypeEnum.Audio) {
              <div><audio [src]="chatMessage.chatFile.url" controls (loadeddata)="loaded()"></audio></div>
            }
            @if (chatMessage.chatFile.mediaType == mediaTypeEnum.Document || chatMessage.chatFile.mediaType == mediaTypeEnum.CompressedFile) {
              <div>
                <img class="file-icon" [src]="chatMessage.chatFile.mediaType == mediaTypeEnum.Document ? '/assets/images/filetypes/file.svg' : '/assets/images/filetypes/zip.png'" (click)="downloadFile()">
              </div>
            }
            <p>{{ chatMessage.chatFile.fileName }}</p>
          }
        </div>
      }
      <div class="text">
        @if (chatMessage.message) {
          <p class="selectable-text" [innerHTML]="chatMessage.message | twemoji">
          </p>
        }
      </div>
      @if (chatMessage.message && chatMessage.translation) {
        <div class="text">
          <p class="translate">
            <i [innerHTML]="chatMessage.translation | twemoji"></i>
          </p>
        </div>
      }
      @if (loadingProgress > 0) {
        <div class="progress-container">
          <div class="progress-bar-container">
            <div class="progress-bar" [style.width.%]="loadingProgress"></div>
          </div>
          <span class="progress-text">{{ loadingProgress }}%</span>
        </div>
      }
      <div class="bottom-line">
        <p>{{ chatMessage.date | date : "HH:mm" }}</p>
        @if (canDelete) {
          <span class="chat-icon" (click)="deleteMessage()" id="deleteMessage">
            <i class="material-icons notranslate small">delete_outline</i>
          </span>
        }
        @if (chatMessage.chatFile?.mediaType == mediaTypeEnum.Image) {
          <span class="chat-icon" (click)="editImage(chatMessage.chatFile?.fileId!,chatMessage.chatFile?.fileName!)" id="editImage">
            <i class="material-icons notranslate small">edit</i>
          </span>
        }
      </div>
    </div>
  </div>
}

@if (chatMessage.type == chatMessageTypeEnum.System) {
  <div class="message system">
    <div class="globe">
      @if (chatMessage.message != chatMessageSystemEnum.REPORT) {
        <div class="text">
          @if (chatMessage.message == chatMessageSystemEnum.ASSISTANCE_OPEN_MESSAGE) {
            <p>{{ chatMessage.userName }} {{ 'ASSISTANCES.OPEN_MESSAGE' | translate }}</p>
          }
          @if (chatMessage.message == chatMessageSystemEnum.ASSISTANCE_CLOSE_MESSAGE) {
            <p>{{ chatMessage.userName }} {{ 'ASSISTANCES.CLOSE_MESSAGE' | translate }}</p>
          }
          @if (chatMessage.message == chatMessageSystemEnum.ASSISTANCE_REOPEN_MESSAGE) {
            <p>{{ chatMessage.userName }} {{ 'ASSISTANCES.REOPEN_MESSAGE' | translate }}</p>
          }
          @if (chatMessage.message == chatMessageSystemEnum.INITIAL_MESSAGE && chatMessage.translation == '') {
            <p>{{ 'CHAT.INITIAL_MESSAGE' | translate }}</p>
          }
          @if (chatMessage.message == chatMessageSystemEnum.INITIAL_MESSAGE && chatMessage.translation != '') {
            <p>{{ chatMessage.translation }}</p>
          }
          @if (chatMessage.message == chatMessageSystemEnum.FINISH_CALL) {
            <p>{{ 'CALL.FINISH_CALL' | translate }} {{ chatMessage.date | date: 'short' }}</p>
          }
        </div>
      }
      @if (chatMessage.message == chatMessageSystemEnum.REPORT && isExpert) {
        <div class="buttons">
          <span id="assistanceReport" title="{{ this.openReportTooltip | translate }}" class="btn btn-default middle" (click)="downloadAssistanceReport()" target="_blank">
            <img src="/assets/images/chat/generate-report.svg" class="hvr-grow" style="width: 35px" />
          </span>
          <span id="sendEmail" title="{{ this.sendReportByEmailTooltip | translate }}" class="chat-icon" (click)="sendEmail()">
            <i class="material-icons notranslate send-email">mail</i>
          </span>
        </div>
      }
    </div>
  </div>
}
